// extracted by mini-css-extract-plugin
module.exports = {"CarouselContainer":"SliderReviews_CarouselContainer__1i7vN"};